import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { COMPANY } from "../../data/site";

export const MobileCallBar = () => (
  <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 p-3 pb-[max(12px,env(safe-area-inset-bottom))]" data-testid="mobile-call-bar">
    <div className="grid grid-cols-2 gap-2 rounded-full bg-forest/95 backdrop-blur-xl p-1.5 shadow-2xl shadow-forest/40">
      <a href={COMPANY.phoneHref} className="btn btn-lime !py-3" data-testid="mobile-bar-call"><Phone className="w-4 h-4" />Appeler</a>
      <Link to="/contact" className="btn btn-ghost-light !py-3" data-testid="mobile-bar-quote"><FileText className="w-4 h-4" />Devis gratuit</Link>
    </div>
  </div>
);
